import React from 'react'
import { useNavigate } from 'react-router-dom'
import { goBackOrHome } from '../utils/navigation'

interface AppBarProps {
  onBack?: () => void
  /**
   * 뒤로가기 버튼을 보일지. 기본은 보임.
   *
   * 돌아갈 데가 없는 화면(온보딩 첫 장)에서 끈다. 자리는 그대로 비워 둬서
   * 제목과 우측 요소가 다른 화면과 같은 위치에 오게 한다.
   */
  showBack?: boolean
  title?: string
  titleAlign?: 'center' | 'left'
  titleFontSize?: number
  rightElement?: React.ReactNode
  variant?: 'default' | 'transparent'
  backIcon?: string
  className?: string
  isBottomBorder?: boolean
  actionSize?: number
}

const AppBar: React.FC<AppBarProps> = ({
  onBack,
  showBack = true,
  title,
  titleAlign = 'center',
  titleFontSize = 16,
  rightElement,
  variant = 'default',
  backIcon = '/images/back-arrow-icon.png',
  className = '',
  isBottomBorder = false,
  actionSize = 48,
}) => {
  const navigate = useNavigate()

  const handleBack = () => {
    if (onBack) {
      onBack()
    } else {
      goBackOrHome(navigate)
    }
  }

  const isTransparent = variant === 'transparent'

  return (
    <div className={`w-full h-48px flex items-center ${className}`}>
      <div
        className={`app-container flex items-center ${
          isBottomBorder ? 'border-b border-472410-20%' : ''
        }`}
      >
        {showBack ? (
          <button
            type="button"
            className="hover:opacity-70"
            onClick={handleBack}
            style={{ width: actionSize, height: 48 }}
          >
            <img
              src={backIcon}
              alt="뒤로가기"
              className="w-full h-full object-contain object-left"
            />
          </button>
        ) : (
          <div style={{ width: actionSize, height: 48 }} />
        )}

        <h2
          className={`flex-1 flex items-center min-w-0 text-style-labelL
            ${
              titleAlign === 'left'
                ? 'justify-start text-left pl-4px'
                : 'justify-center text-center'
            }
            ${isTransparent ? 'text-white' : 'text-brown-80%-main'}
          `}
          style={{ fontSize: titleFontSize }}
        >
          {/*
            긴 제목은 …으로 줄인다.
            truncate를 h2에 직접 걸면 동작하지 않는다. text-overflow는 블록 컨테이너에만
            적용되는데 h2는 정렬 때문에 flex라, 안쪽 글자는 익명 플렉스 아이템이 되어
            잘리지 않고 그대로 넘친다. 그래서 span으로 감싸 거기에 건다.
            min-w-0이 함께 있어야 플렉스 아이템이 내용보다 작게 줄어든다.
          */}
          <span className="min-w-0 truncate">{title ?? ''}</span>
        </h2>

        {/* whitespace-nowrap: 헤더 우측 텍스트 버튼(완료/수정/추가 등)이
            좁은 슬롯에서 갤럭시 한글 글리프 때문에 음절 단위(완/료)로
            줄바꿈되는 것을 전역 방어. white-space는 상속되므로 하위 버튼·텍스트까지 적용됨. */}
        <div
          className="flex items-center justify-end whitespace-nowrap"
          style={{ width: actionSize, height: 48 }}
        >
          {rightElement}
        </div>
      </div>
    </div>
  )
}

export default AppBar
